import axios, { AxiosInstance } from 'axios';
import { demoReady } from 'demo/bootState';
import { isDemo } from 'helpers/utility';

/**
 * Holds every request until `ready` resolves, then sends it through the instance's current
 * adapter. axios copies the adapter into the request config before interceptors run, so a
 * request fired before the mock was installed would otherwise still use the real network.
 */
export const holdRequestsUntil = (instance: AxiosInstance, ready: Promise<void>): void => {
  instance.interceptors.request.use(async (config) => {
    await ready;
    return { ...config, adapter: instance.defaults.adapter };
  });
};

// src/index.jsx imports this module before AtsApp, whose import already fires requests.
if (isDemo()) {
  holdRequestsUntil(axios, demoReady);
}
